<ng-template vdrDialogTitle>
{{ currentTitle ?? ('link.createMission' | translate) }}
</ng-template>

<vdr-action-bar>
  <vdr-ab-left>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="languageCode$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector>
    </vdr-ab-left>
  </vdr-ab-left>
</vdr-action-bar>

<form [formGroup]="detailForm" class="mt-2">
  <div class="form-grid">

    <vdr-form-field [label]="'quantity' | translate" for="quantity"
    >
      <input
        id="text"
        type="number"
        formControlName="quantity"
      />
    </vdr-form-field>

    <vdr-form-field [label]="'percent' | translate" for="percent"
    >
      <input
        id="text"
        type="number"
        formControlName="percent"
      />
    </vdr-form-field>
  </div>
</form>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button
    *ngIf="!entity; else updateBtn"
    type="submit"
    (click)="save()"
    class="btn btn-primary"
    [disabled]="detailForm.pristine || detailForm.invalid"
  >
    {{ "common.save" | translate }}
  </button>
  <ng-template #updateBtn>
    <button
      type="submit"
      (click)="update()"
      class="btn btn-primary"
      [disabled]="detailForm.pristine || detailForm.invalid"
    >
      {{ "common.update" | translate }}
    </button>
  </ng-template>
</ng-template>
